import React, { useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { observer, useObserver } from 'mobx-react-lite';
import Moment from 'react-moment';

/* packages */
import { Lists } from '../../lib-atomic';
import { LocalStorage } from '../../lib-atomic-functions';
import { ModuleText } from '../../lib-atomic-design-section';
/* packages */

/* modules */
import OrdersLoader from '../loader';
/* modules */

/* functions */
import { CompanySearch } from '../../app-module-company-container/functions';
/* functions */

import CONFIG from '../config';

/* CONSTANTS */
const IdTpl = (data, obj) => {
  const link = "/company/detail/" + data;
  return <ModuleText>
    <Link to={link}><b>{data}</b></Link>
  </ModuleText>
}
const NameTpl = (data, obj) => {
  return <ModuleText>
    <b>{data}</b><br/>
    { obj.emailAddress && <Fragment><span>{obj.emailAddress}</span> <br/></Fragment> }
    { obj.mobile && <Fragment><span>{obj.mobile}</span> <br/></Fragment> }
    { obj.NZBN && <Fragment><span>NZBN: {obj.NZBN}</span> <br/></Fragment> }
  </ModuleText>
}
const AddressTpl = (data, obj) => {
  return <ModuleText>
    <b>{data}</b>
  </ModuleText>
}
const NZBNTpl = (data, obj) => {
  return <ModuleText>
    <b>{data}</b>
  </ModuleText>
}
const LABEL = (data) => {
  return <ModuleText>
    <small><b>{ data }</b></small><br/><br/>
  </ModuleText>
}

const config = [
  { field: "id", template: IdTpl, label: LABEL("COMPANY #") },
  { field: "name", template: NameTpl, label: LABEL("COMPANY DETAILS") },
  { field: "physicalAddress1", template: AddressTpl, label: LABEL("PO BOX ADDRESS") },
  { field: "physicalAddress2", template: AddressTpl, label: LABEL("DELIVERY ADDRESS") },
]
/* CONSTANTS */

const Index = observer((props) => {

  const { login } = LocalStorage.getLS();
  const { token } = login;

  const searchQuery = props.location.search;

  /* states */
  const { companyListContext, companyListMethod, companyListData } = CompanySearch({CONFIG, token, searchQuery});

  useEffect(() => {
    companyListMethod();
  }, [searchQuery]);
  /* states */

  const { clients } = companyListData ? companyListData : false;
  /* data props */
  const listData = { data: clients, config }
  /* data props */

  /* laoder */
  if (!clients) return <OrdersLoader />

  return <Lists.Normal {...listData} />

});

export default Index;
